import React from 'react';

import { UiKit } from 'components';
import { useRequestReasonConfig } from '../context';

/**
 * @param {Object} props
 * @param {import('utils/types').ButtonSize} [props.size] - The size of the button.
 * @param {string} [props.className] - Additional class names for the button.
 * @param {React.ReactNode} props.children - The content of the button.
 */
export default function Trigger({
  size = 'md',
  className = '',
  children = null
}) {
  const { onFormOpen } = useRequestReasonConfig();

  return (
    <UiKit.Button
      size={size}
      variant="ghost"
      onClick={onFormOpen}
      className={className}
    >
      {children}
    </UiKit.Button>
  );
}
